<template>
  <div id="home">
    <HomeSearch />
    <!-- Banners -->
    <v-layout align-center justify-center row wrap>
      <v-flex mt-4 sm6 text-xs-center xs11>
        <base-banners
          :bannerPositionId="state"
          :key="state"
          pageId="PAGES0000001"
          v-for="state in states"
        ></base-banners>
      </v-flex>
    </v-layout>
    <!-- <HomeContentList /> -->
    <!-- <KnowledgeList /> -->
    <!-- banners -->
    <base-banners></base-banners>
    <div class="my-5"></div>
  </div>
</template>

<script>
const HomeSearch = () => import('../components/home/HomeSearch.vue')
// const HomeContentList = () => import('../components/home/HomeContentList.vue')
// const KnowledgeList = () => import('../components/knowledge/KnowledgeList.vue')

export default {
  name: 'home',
  components: {
    HomeSearch
    // HomeContentList,
    // KnowledgeList
  },
  data() {
    return {
      states: [
        'BANNERPOS0000006',
        'BANNERPOS0000007',
        'BANNERPOS0000008',
        'BANNERPOS0000009',
        'BANNERPOS0000010'
      ]
    }
  },
  created() {}
}
</script>
<style lang="scss" scoped></style>
